<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- <template #monthTab>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="默认当月" name="1"></el-tab-pane>
          <el-tab-pane label="上月" name="2"></el-tab-pane>
        </el-tabs>
      </template> -->
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :getTotal="getTotal" :showIndex="true" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"></Table>
    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      // activeName: '1',
      baseUrl: 'abnormal',
      getListUrl: 'rec',
      modalSubmitUrl: 'addedu',
      breadcrumb: [
        { name: "财务管理" },
        { name: "预警管理" },
      ],
      formInline: {
        fleet: '',
        time: null,
        type: null,
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          label: "车队长",
          placeholder: "",
          options: [],
        },
        {
          label: "时间选择",
          keyName: "time",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
        {
          label: "异常类型",
          keyName: "type",
          placeholder: "请选择",
          type: "select",
          options: [
            { label: '全部', value: '' },
            { label: '负毛利', value: 1, },
            { label: '欠款逾期', value: 2, },
            { label: '油耗过高', value: 3, },
            { label: '费用过高', value: 4, },
            { label: '车辆超速', value: 5, },
          ],
        },
      ],
      title: '添加',
      viewMode: false,
      mform: { status: undefined, result: undefined },
      mrules: {
        status: [
          {
            required: true,
            message: '请选择处理状态',
            trigger: 'blur',
          }
        ],
        result: [
          {
            required: true,
            message: '请填写处理结果',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "处理状态",
          keyName: "status",
          placeholder: "请选择",
          type: "select",
          options: [
            { label: '待处理', value: 1, },
            { label: '暂缓处理', value: 2, },
            { label: '已处理', value: 3, },
          ],
        },
        {
          label: "处理结果",
          keyName: "result",
          err: "请填写处理结果",
          type: "textarea",
          rows: 3,
        },
      ],
      cols: [
        { keyName: "type", label: "异常类型" },
        { keyName: "fleetname", label: "所属车队" },
        { keyName: "abnormal", label: "异常描述", minwidth: 210 },
        { keyName: "abnormaltime", label: "报警日期" },
        { keyName: "status", label: "处理状态" },
        { keyName: "dealname", label: "处理人" },
        { keyName: "result", label: "处理结果", minwidth: 210 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data)
            this.showDialog()
          },
        },
        {
          ...this.feeBtn,
          cb: ({ order_id }) => {
            const { user_group_id } = this.user
            let mode = 'edit'
            if (user_group_id != 1) {
              mode = 'view'
            }
            this.$router.push(
              `/finance/abnormalFee?id=${order_id}&mode=${mode}`
            );
          },
        },
      ],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      if (['fleet', 'type'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    getItem({ id }) {
      const url = `${this.baseUrl}/info`
      const params = { id }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          const { status, result } = data
          this.mform = { ...this.mform, id, result }
          this.mformCtrl.map(v => {
            if (v.keyName === 'status') {
              v.options.map(c => {
                if (c.label == status) {
                  this.mform['status'] = c.value
                }
              })
            }
          })
          this.title = '修改'
          // console.log('mform', { ...this.mform })
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      // 车队长登录，默认搜索当前队长
      this.formInline.fleet = id
      // 不显示队长控件
      this.formCtrl.splice(0, 1)
      // 重置时保留队长检索
      this.baseParams.push('fleet')
    }
  },
  mounted() {
    this.getFleet();
    const { user_group_id } = this.user
    if (user_group_id == 5) {
      // 由于有了baseParams手动触发首次请求
      this.$nextTick(this.getList);
    }
  },
};
</script>

<style lang="less" scoped>
// /deep/ .el-tabs {
//   width: 172px;
//   float: left;
//   margin-right: 40px;

//   .el-tabs__nav-wrap {
//     border: 1px solid #2691FF;
//     border-radius: 3px;
//     padding: 0;

//     .el-tabs__nav-next,
//     .el-tabs__nav-prev {
//       display: none;
//     }

//     .el-tabs__item {
//       width: 85px;
//       padding: 0;
//       text-align: center;
//       color: #2691FF;

//       &.is-active {
//         color: #fff;
//         background: #2691FF;
//       }
//     }
//   }
// }

/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

/deep/ .el-tabs__active-bar {
  height: 0;
}

/deep/ .dialog {
  // .el-form {
  //   padding-right: 0 !important;

  //   .el-form-item .el-form-item__content .content {
  //     display: block;

  //     .unit {
  //       line-height: 30px;
  //       margin: 0 auto;
  //       font-size: 12px;
  //       color: #FF6756;
  //     }
  //   }

  .el-input {
    width: 230px;
  }
}
</style>
